export enum TGlobalContainerDesigns {
  GlobalCont1 = 'GlobalCont1',
  GlobalCont2 = 'GlobalCont2',
  GlobalCont3 = 'GlobalCont3',
  GlobalCont4 = 'GlobalCont4',
}

export enum TGlobalIcoTextDesigns {
  GlobalIcoText1 = 'GlobalIcoText1',
  GlobalIcoText2 = 'GlobalIcoText2',
  GlobalIcoText3 = 'GlobalIcoText3',
  GlobalIcoText4 = 'GlobalIcoText4',
  GlobalIcoText5 = 'GlobalIcoText5',
  GlobalError400 = 'GlobalError400',
}
